<template>
  <div id="updateInfo" class="col-12 p-0">
    <div class="row">
      <SelectSettings v-if="selected === null" />
    </div>
    <div v-if="selected == null" class="mt-5 px-4 row col-12">
      <div
        class="alert alert-dark alert-sm alert-info-custom info-alert"
        role="alert"
      >
        <h5>
          <span
            class="icon icon-info text-primary mr-2 mt-2"
            style="    margin-left: 10px;
    position: relative;
    top: 2px !important;
}"
          ></span>
          Aún no has elegido una categoría
        </h5>
      </div>
      <!--p class="alert alert-warning col-12" role="alert">Aún no has elegido una categoría</p-->
      <div class="row col-12 d-flex">
        <img
          src="@/assets/images/platformSettings/undraw_Dropdown_menu_re_jqqs 1.svg"
          alt=""
          class="col-5 mt-5"
        />
      </div>
    </div>
    <div class="row" v-if="selected === 'lineas-negocios'">
      <LineBusiness />
    </div>

    <div class="row" v-if="selected === 'bolsas-apoyo'">
      <SupportBag />
    </div>

    <div class="row" v-if="selected === 'escenarios'">
      <Scenarios />
    </div>

    <div class="row" v-if="selected === 'cargos'">
      <Charges />
    </div>

    <div class="row" v-if="selected === 'punto-ventas'">
      <PointSales />
    </div>

    <div class="row" v-if="selected === 'grupo-cargos'">
      <GroupOfCharges />
    </div>
    <div class="row" v-if="selected === 'bancos'">
      <Banks />
    </div>
    <div class="row" v-if="selected === 'zonas'">
      <Zones />
    </div>
    <div class="row" v-if="selected === 'empleados'">
      <Employees />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import LineBusiness from "./updateInfo/lineBusiness.vue";
import SupportBag from "./updateInfo/supportBag.vue";
import Scenarios from "./updateInfo/scenarios.vue";
import Charges from "./updateInfo/charges.vue";
import PointSales from "./updateInfo/pointsSales.vue";
import GroupOfCharges from "./updateInfo/groupOfCharges.vue";
import Banks from "./updateInfo/banks.vue";
import Zones from "./updateInfo/zones.vue";
import Employees from "./updateInfo/employees.vue";

export default {
  name: "UpdateInfo",
  components: {
    SelectSettings,
    LineBusiness,
    SupportBag,
    Scenarios,
    Charges,
    PointSales,
    GroupOfCharges,
    Banks,
    Zones,
    Employees,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("modPlatformSettings", ["selected", "loading"]),
  },
};
</script>

<style lang="scss">
#updateInfo {
  .info-alert {
    padding: 0px;
    //margin-left:20px;
    margin-top: 20px;
    width: 383px;
    height: 36px;
    position: relative !important;
    background: #e6f7ff !important;
    border: 1px solid #0075ff;
    box-sizing: border-box;
    border-radius: 4px;
    span {
      width: 383px;
      height: 36px;

      /* body regular */

      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      /* or 175% */

      /* content/09 */

      color: #263238;
    }
  }
  .custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .btn-create {
    padding: 12px;
    border-radius: 20px;
    background-color: #269887;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    transition: 0.5s;

    span {
      font-size: 30px;
      line-height: 0;
      margin: 0 5px;
      font-weight: 500;
    }
  }
  .btn-create:hover {
    background-color: #27a391;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  }
  @media only screen and (max-width: 600px) {
    .new-responsive {
      position: fixed;
      z-index: 10;
      top: 83%;
      width: 80%;
      text-align: center;
      right: 10%;
      justify-content: center;
      box-shadow: 0 0 10px white;
    }
  }
}
.modal-content {
  /*select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }*/
  .modal-header {
    border: none;
  }
  .input-vp2,
  /*button {
    padding: 10px 10px;
    font-size: 15px;
    height: 40px;
    border-radius: 10px;
  }*/
  .btn-outline-success {
    border-radius: 20px;
    color: #269887;
    border-color: #269887;
  }
  .btn-outline-success:hover,
  .btn-success {
    color: white;
    background-color: #269887;
    border-color: #269887;
  }
  .btn-success:hover {
    background-color: #27a391;
  }
  .regular {
    background-color: white;
    border: none;
    color: #269887;
  }
  .delete {
    background-color: white;
    border: none;
    color: #da1414;
  }
  h3 {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
  }
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .loaderSmall {
    display: block;
    z-index: 1;
    width: 30px;
    height: 30px;
    margin: 20px;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #8f8f8f;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
}
</style>